export enum CreditReviewStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Ready = 'ready',
    Failed = 'failed',
}
